/** biome-ignore-all lint/a11y/noStaticElementInteractions: desktop hover behavior is handled on the wrapper */

"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRef, useState } from "react";
import { A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Bg_Section_Top from "~/public/assets/backgrounds/bg-section-bottom.png";
import { ServiceDesktopCard } from "./service-desktop-card";
import { ServiceMobileCard } from "./service-mobile-card";
import { defaultServices, type ServiceItem } from "./services-content";
import { useServicesSectionAnimation } from "./use-services-section-animation";
export type ServicesSectionProps = {
  tag?: string;
  title?: string;
  services?: ServiceItem[];
  defaultLinkLabel?: string;
  defaultLinkHref?: string;
  isBgLight?: boolean;
};
export default function ServicesSection(t0) {
  const $ = _c(42);
  const {
    tag: t1,
    title: t2,
    services: t3,
    defaultLinkLabel: t4,
    defaultLinkHref: t5,
    isBgLight: t6
  } = t0;
  const tag = t1 === undefined ? "Servi\xE7os" : t1;
  const title = t2 === undefined ? "O que oferecemos de melhor" : t2;
  const services = t3 === undefined ? defaultServices : t3;
  const defaultLinkLabel = t4 === undefined ? "Saiba mais" : t4;
  const defaultLinkHref = t5 === undefined ? "#contato" : t5;
  const isBgLight = t6 === undefined ? true : t6;
  const sectionRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  useServicesSectionAnimation(sectionRef);
  const t7 = `relative border-b border-gray-300 ${isBgLight ? "bg-gray-1000" : "bg-gray-1100"}`;
  let t8;
  if ($[0] !== isBgLight) {
    t8 = !isBgLight && <Image src={Bg_Section_Top} alt="Background section" aria-hidden="true" className="pointer-events-none absolute rotate-180 opacity-80 top-0 z-10 h-full min-h-145 max-h-145 w-full hidden md:block" priority={false} />;
    $[0] = isBgLight;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const t9 = `container border-t overflow-visible md:border-x border-gray-300 pb-20 px-6 lg:px-18 xl:px-24!
        ${isBgLight ? " xl:pb-160" : "xl:pb-160"}`;
  let t10;
  if ($[2] !== isBgLight || $[3] !== tag || $[4] !== title) {
    t10 = !isBgLight && <div className="pt-24"><p className="tag">{tag}</p><h2 className="title">{title}</h2></div>;
    $[2] = isBgLight;
    $[3] = tag;
    $[4] = title;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== isBgLight || $[7] !== title) {
    t11 = isBgLight && <h2 className="sr-only">{title}</h2>;
    $[6] = isBgLight;
    $[7] = title;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      enabled: true
    };
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [A11y];
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== defaultLinkHref || $[12] !== defaultLinkLabel || $[13] !== services) {
    let t15;
    if ($[15] !== defaultLinkHref || $[16] !== defaultLinkLabel) {
      t15 = service => <SwiperSlide className="max-w-72 md:max-w-80" key={service.title}><div className="services-mobile-card h-full"><ServiceMobileCard defaultLinkHref={defaultLinkHref} defaultLinkLabel={defaultLinkLabel} service={service} /></div></SwiperSlide>;
      $[15] = defaultLinkHref;
      $[16] = defaultLinkLabel;
      $[17] = t15;
    } else {
      t15 = $[17];
    }
    t14 = services.map(t15);
    $[11] = defaultLinkHref;
    $[12] = defaultLinkLabel;
    $[13] = services;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[18] !== t14) {
    t15 = <div className="pt-18 px-6 lg:px-18 xl:hidden"><Swiper a11y={t12} className="overflow-visible!" modules={t13} slidesPerView="auto" spaceBetween={16}>{t14}</Swiper></div>;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t15 || $[23] !== t9) {
    t16 = <div className="md:container-padding"><div className={t9}>{t10}{t11}{t15}</div></div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t15;
    $[23] = t9;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setActiveIndex(null);
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== activeIndex || $[27] !== defaultLinkHref || $[28] !== defaultLinkLabel || $[29] !== services) {
    let t19;
    if ($[31] !== activeIndex || $[32] !== defaultLinkHref || $[33] !== defaultLinkLabel) {
      t19 = (service_0, index) => {
        const isActive = index === activeIndex;
        return <div className="services-desktop-card flex flex-1" key={service_0.title}><ServiceDesktopCard defaultLinkHref={defaultLinkHref} defaultLinkLabel={defaultLinkLabel} isActive={isActive} onMouseEnter={() => setActiveIndex(index)} service={service_0} /></div>;
      };
      $[31] = activeIndex;
      $[32] = defaultLinkHref;
      $[33] = defaultLinkLabel;
      $[34] = t19;
    } else {
      t19 = $[34];
    }
    t18 = services.map(t19);
    $[26] = activeIndex;
    $[27] = defaultLinkHref;
    $[28] = defaultLinkLabel;
    $[29] = services;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[35] !== t18) {
    t19 = <div className="absolute bottom-24 w-full left-0 right-0 hidden px-6 lg:px-18 xl:block 3xl:px-24!"><div className="flex gap-2 md:gap-7 overflow-visible" onMouseLeave={t17}>{t18}</div></div>;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t16 || $[38] !== t19 || $[39] !== t7 || $[40] !== t8) {
    t20 = <section ref={sectionRef} className={t7} id="servicos">{t8}{t16}{t19}</section>;
    $[37] = t16;
    $[38] = t19;
    $[39] = t7;
    $[40] = t8;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
}